import { useState } from 'react';
import { Box, Menu, MenuItem, useMediaQuery, Theme } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { getMemories, setCreateMemoryStep, togglePinMemory } from '@/store/actions';
import { currentStorySelector } from '@/store/selectors';

const EditMemoryDropdown = ({ mediaContent, deleteMemory, onClose, canPin }: any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const story = useSelector(currentStorySelector);
  const [profileAnchorEl, setProfileAnchorEl] = useState<null | HTMLElement>(null);
  const router = useRouter();
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();

  const handleClickMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setProfileAnchorEl(null);
  };

  const handleMenuItemClick = (key: string) => {
    if (key === 'pin' || key === 'unpin') {
      dispatch(togglePinMemory({ ...mediaContent, isPinned: key === 'pin' ? true : false }));
      dispatch(getMemories({story_id: story?.id, publicAccess: false}));
      onClose();
    } else if (key === 'delete') {
      deleteMemory();
    } else if (key === 'edit') {
      dispatch(setCreateMemoryStep(1));
      router.push(`/app/story/${story?.url}/memory/create?memoryId=${mediaContent?.id}`);
    }
  };



  const buttonBackground = router.pathname === '/app/story/[id]' ? 'white' : 'black';
  const iconSrc = router.pathname === '/app/story/[id]' ? '/icons/down-arrow-dark.svg' : '/icons/down-arrow-light.svg';

  return (
    <div>
      <Box onClick={handleClickMenu} sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
        <Image priority
          src='/icons/three-dots.svg'
          alt='logo'
          style={{ marginTop: '4px' }}
          width={16}
          height={16}
          quality={80}

        />
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}

          PaperProps = {{
            sx: {
              borderRadius: '12px',

            }
          }}

        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        {[
          ...(canPin
            ? [
                {
                  key: mediaContent?.is_pinned ? 'unpin' : 'pin',
                  label: mediaContent?.is_pinned ? 'Unpin' : 'Pin to main grid',
                  icon: '/icons/Pinicon.svg',
                  largeFont: false,
                },
              ]
            : []),
          { key: 'edit', label: 'Edit Memory', icon: '/icons/pencil-single.svg', largeFont: false },
          { key: 'delete', label: 'Delete Memory', icon: '/icons/delete-red.svg', largeFont: true },
        ].map((item, index) => (
          <div key={item.label}>
            <MenuItem
              onClick={() => {
                handleMenuItemClick(item?.key);
              }}
              sx={{
                justifyContent: 'space-between',
                width: '180px',

                fontSize: item.largeFont ? '16px' : '16px',
                color: item.largeFont ? 'red' : '#000',

                '&:hover': {
                  backgroundColor: 'rgba(0, 114, 206, 1)',
                  color: '#fff !important',
                  '& .menu-icon': {
                    filter: 'brightness(0) invert(1)',
                  },
                },
              }}>
              {item.label}
              <Image priority className='menu-icon' src={item.icon} alt='logo' width={18} height={18} quality={80} style={{}} />
            </MenuItem>

            {index < 2 && (
              <hr style={{ height: '0.1px', backgroundColor: '#C6D7E7', border: 'none', margin: '0' }} />
            )}
          </div>
        ))}
      </Menu>
    </div>
  );
};

export default EditMemoryDropdown;
